import { render, staticRenderFns } from "./AppleDownloadView.vue?vue&type=template&id=6936c3d8&scoped=true&"
import script from "./AppleDownloadView.vue?vue&type=script&lang=js&"
export * from "./AppleDownloadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6936c3d8",
  null
  
)

export default component.exports